<template>
  <nav class="navbar">
    <div class="nav-container">
      <!-- Logo部分 -->
      <div class="nav-logo">
        <router-link to="/" class="logo-link">
          <div class="logo-icon">
          <img src="../assets/logo.png" alt="logo" />
          </div>
          <div class="logo-text">
            <span class="brand-name">雪顶科技</span>
            <!-- <span class="brand-english">Tamme</span> -->
            <span class="brand-desc">数字化方案专家</span>
          </div>
        </router-link>
      </div>
      
      <!-- 导航菜单 -->
      <div class="nav-menu" :class="{ active: isMenuOpen }">
        <router-link to="/" class="nav-link" @click="closeMenu">首页</router-link>
        <div class="nav-dropdown">
          <router-link to="/products" class="nav-link" @click="closeMenu">
            产品与服务
          </router-link>
        </div>
        <router-link to="/ai-digital-human" class="nav-link nav-link-new" @click="closeMenu">
          AI数字人
          <span class="new-badge">NEW</span>
        </router-link>
        <!-- <router-link to="/solutions" class="nav-link" @click="closeMenu">行业解决方案</router-link> -->
        <router-link to="/cases" class="nav-link" @click="closeMenu">客户案例</router-link>
        <!-- <router-link to="/resources" class="nav-link" @click="closeMenu">资料中心</router-link> -->
        <router-link to="/partners" class="nav-link" @click="closeMenu">代理合作</router-link>
        <router-link to="/about" class="nav-link" @click="closeMenu">关于我们</router-link>
      </div>
      
      <!-- 右侧操作区 -->
      <div class="nav-actions">
        <a href="tel:400-688-5235" class="phone-btn">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" class="phone-icon">
            <path d="M3.654 1.328l-1.215.716A2.6 2.6 0 001.328 5.19c.425 6.375 7.486 13.436 13.861 13.861a2.6 2.6 0 003.147-1.111l.716-1.215a1.2 1.2 0 00-.35-1.529l-2.4-1.714a1.2 1.2 0 00-1.444.101l-1.331 1.063c-.7.56-1.745.488-2.362-.129C10.54 13.893 9.6 12.993 8.8 11.8c-.617-.617-.689-1.662-.129-2.362l1.063-1.331a1.2 1.2 0 00.101-1.444L8.121 4.264a1.2 1.2 0 00-1.529-.35l-1.215.716a2.6 2.6 0 00-1.111 3.147c.425 6.375 7.486 13.436 13.861 13.861z" fill="#6B7280"/>
          </svg>
          400-688-5235
        </a>
        <button class="trial-btn" @click="handleTrial">免费试用</button>
        
        <!-- 移动端汉堡菜单 -->
        <div class="hamburger" @click="toggleMenu" :class="{ active: isMenuOpen }">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
    
    <!-- 客服弹窗 -->
    <CustomerService :visible="showCustomerService" @close="closeCustomerService" />
  </nav>
</template>

<script>
import CustomerService from './CustomerService.vue'

export default {
  name: 'AppNavbar',
  components: {
    CustomerService
  },
  data() {
    return {
      isMenuOpen: false,
      showCustomerService: false
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    },
    closeMenu() {
      this.isMenuOpen = false
    },
    handleTrial() {
      // 显示客服弹窗
      this.showCustomerService = true
    },
    closeCustomerService() {
      this.showCustomerService = false
    }
  }
}
</script>

<style scoped>
.navbar {
  background: #ffffff;
  border-bottom: 1px solid #f1f3f4;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  height: 72px;
}

.nav-container {
  max-width: 1320px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}

/* Logo部分 */
.nav-logo {
  flex-shrink: 0;
}

.logo-link {
  display: flex;
  align-items: center;
  text-decoration: none;
  gap: 12px;
}

.logo-icon {
  width: 60px;
  height: 60px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-text {
  display: flex;
  align-items: center;
  gap: 8px;
}

.brand-name {
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
  letter-spacing: -0.5px;
}

.brand-english {
  font-size: 16px;
  font-weight: 400;
  color: #6b7280;
  margin-left: -4px;
}

.brand-desc {
  font-size: 14px;
  color: #9ca3af;
  margin-left: 4px;
  border-left: 1px solid #e5e7eb;
  padding-left: 8px;
}

/* 导航菜单 */
.nav-menu {
  display: flex;
  align-items: center;
  gap: 22px;
  flex: 1;
  justify-content: center;
  margin: 0 24px;
  flex-wrap: nowrap;
  min-width: 0;
}

.nav-dropdown {
  position: relative;
}

.nav-link {
  display: flex;
  align-items: center;
  gap: 4px;
  text-decoration: none;
  color: #374151;
  font-size: 15px;
  font-weight: 500;
  padding: 8px 0;
  position: relative;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.nav-link-new {
  gap: 8px;
}

.new-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 18px;
  padding: 0 6px;
  border-radius: 999px;
  background: #ef4444;
  color: #ffffff;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.3px;
}

.nav-link:hover {
  color: #3470ff;
}

.nav-link.router-link-active {
  color: #3470ff;
  font-weight: 600;
}

.nav-link.router-link-active::after {
  content: '';
  position: absolute;
  bottom: -16px;
  left: 50%;
  transform: translateX(-50%);
  width: 20px;
  height: 2px;
  background: #3470ff;
  border-radius: 1px;
}

.dropdown-icon {
  margin-left: 2px;
  transition: transform 0.2s ease;
}

.nav-dropdown:hover .dropdown-icon {
  transform: rotate(180deg);
}

/* 右侧操作区 */
.nav-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.phone-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  text-decoration: none;
  color: #6b7280;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 12px;
  border-radius: 6px;
  transition: all 0.2s ease;
  border: 1px solid transparent;
}

.phone-btn:hover {
  color: #3470ff;
  background: #f8faff;
  border-color: #e1e8ff;
}

.phone-icon {
  width: 14px;
  height: 14px;
}

.trial-btn {
  background: #3470ff;
  color: #ffffff;
  border: none;
  padding: 9px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.trial-btn:hover {
  background: #2563eb;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(52, 112, 255, 0.3);
}

/* 汉堡菜单 */
.hamburger {
  display: none;
  flex-direction: column;
  cursor: pointer;
  gap: 3px;
  padding: 8px;
  margin-left: 8px;
}

.hamburger span {
  width: 20px;
  height: 2px;
  background: #374151;
  transition: 0.3s;
  border-radius: 1px;
}

.hamburger.active span:nth-child(1) {
  transform: rotate(45deg) translate(4px, 4px);
}

.hamburger.active span:nth-child(2) {
  opacity: 0;
}

.hamburger.active span:nth-child(3) {
  transform: rotate(-45deg) translate(5px, -5px);
}

/* 移动端样式 */
@media (max-width: 1024px) {
  .nav-menu {
    gap: 16px;
    margin: 0 12px;
  }
  
  .brand-desc {
    display: none;
  }
}

@media (max-width: 1200px) {
  .phone-btn {
    padding: 8px 10px;
    font-size: 13px;
  }

  .trial-btn {
    padding: 8px 12px;
    font-size: 13px;
  }

  .nav-link {
    font-size: 14px;
  }

  .nav-menu {
    gap: 14px;
  }
}

@media (max-width: 768px) {
  .nav-container {
    padding: 0 16px;
  }
  
  .nav-menu {
    position: fixed;
    top: 72px;
    left: 0;
    right: 0;
    background: #ffffff;
    flex-direction: column;
    padding: 24px;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
    transform: translateY(-100%);
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
    margin: 0;
    gap: 0;
    border-top: 1px solid #f1f3f4;
  }

  .nav-menu.active {
    transform: translateY(0);
    opacity: 1;
    visibility: visible;
  }

  .hamburger {
    display: flex;
  }

  .nav-link {
    padding: 16px 0;
    border-bottom: 1px solid #f1f3f4;
    width: 100%;
    justify-content: space-between;
  }
  
  .nav-link:last-child {
    border-bottom: none;
  }
  
  .brand-english {
    display: none;
  }
  
  .phone-btn {
    display: none;
  }
}

@media (max-width: 480px) {
  .logo-text {
    gap: 4px;
  }
  
  .brand-name {
    font-size: 18px;
  }
  
  .trial-btn {
    padding: 8px 16px;
    font-size: 13px;
  }
}
</style> 
 